import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data is "fresh" for 30s (avoids duplicate fetches while a page renders),
      // but we still refetch on every mount so navigating via the sidebar always
      // hits the API. Without this, returning to a page within the staleTime
      // window shows cached/old data and skips the request. Cached data renders
      // instantly while the fresh response loads in the background.
      staleTime: 30 * 1000,
      refetchOnMount: 'always',
      retry: 1,
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: 0,
    },
  },
})
